// Layouts are registered by the page that actually renders them. A URL alone
// cannot tell us a shop's permitted columns, workflow, or selected report.
const layouts = new Map();
const MAX_LAYOUTS = 40;
let activeContext = null;

export function destinationLayoutContext(props = {}) {
  return JSON.stringify([
    props.auth?.user?.id ?? props.auth?.user?.user_id,
    props.auth?.user?.permissions,
    props.auth?.user?.level_access,
    props.master_config,
    props.toggles,
    props.permissions,
    props.shop_management_scopes,
  ]);
}

function keyFor(value, origin) {
  try {
    const url = new URL(String(value), origin);
    if (url.origin !== origin || !/^\/shop\/[^/]+\/shop-management(?:\/|$)/.test(url.pathname))
      return null;
    url.hash = '';
    url.searchParams.sort();
    return `${url.pathname.replace(/\/+$/, '')}${url.search}`;
  } catch {
    return null;
  }
}

function selectContext(context) {
  if (activeContext !== context) {
    layouts.clear();
    activeContext = context;
  }
}

export function rememberDestinationSkeleton(value, origin, context, descriptor) {
  selectContext(context);
  const key = keyFor(value, origin);
  if (!key) return;
  if (!descriptor?.component) {
    layouts.delete(key);
    return;
  }
  // Keep presentation metadata only; never retain reactive page records or
  // executable form state in a preview of a previously visited destination.
  const props = JSON.parse(JSON.stringify(descriptor.props || {}));
  layouts.delete(key);
  layouts.set(key, { component: descriptor.component, props, title: descriptor.title || 'page' });
  if (layouts.size > MAX_LAYOUTS) layouts.delete(layouts.keys().next().value);
}

export function resolveDestinationSkeleton(value, origin, context) {
  selectContext(context);
  return layouts.get(keyFor(value, origin)) || null;
}
